import loadScript from '@/utils/dynamicLoadScript';
import Constants from '@/constants.js';
export default function initRecurly() {
  return new Promise((resolve, reject) => {
    loadScript('recurly', 'https://js.recurly.com/v3/recurly.js', err => {
      if (err) {
        console.error(err);
        reject(err);
      }
      if (recurly && !recurly.configured) {
        recurly.configure(Constants.RECURLY_PUBLIC_KEY);
      }
      resolve();
    });
  });
}
